export const ROUTE_PATHS = {
  PUBLIC_ROUTES: {
    DEFAULT: "/",
    LOGIN: "/login",
    REGISTER: "/register",
    RESET_PASSWORD: "/reset-password"
  },

  DASHBOARD: {
    LIST: "/dashboard",
  },

  BUILDING: {
    LIST: "/building",
    ADD: "/building/add",
    EDIT: "/building/edit/:id",
  },

  RENTAL_PROPERTY: {
    LIST: "/rental-property",
    ADD: "/rental-property/add",
    EDIT: "/rental-property/edit/:id",
  },

  TENANT: {
    LIST: "/tenant",
    ADD: "/tenant/add",
    EDIT: "/tenant/edit/:id",
  },

  INVOICE: {
    LIST: "/invoice",
    ADD: "/invoice/add",
    EDIT: "/invoice/edit/:id",
  },

  REPORT: {
    LIST: "/reports",
  },

  USER: {
    PROFILE: "/profile",
  },

  SETTING: {
    LIST: "/setting",
    BACKUP: "/backup",
  },
};